import { useWindowDimensions } from "react-native";

import { Stack } from "@/components/atoms";
import OrganizationForm from "@/features/invitations/components/organisms/OrganizationForm";
import useMobileScreen from "@/hooks/useMobileScreen";
import useSetPageTitle from "@/hooks/useSetPageTitle";

/**
 * Container component for creating a new organization.
 * Renders the organization form with responsive width handling.
 */
const CreateOrganizationContainer = () => {
  const { width } = useWindowDimensions();
  const isSmallScreen = useMobileScreen();
  const widthContent = isSmallScreen ? width : 750;

  useSetPageTitle("Create Organization");

  return (
    <Stack
      className="self-center"
      // eslint-disable-next-line no-restricted-syntax -- runtime container width (measured window width when small-screen); no closed sizing token covers it
      UNSAFE_style={{ width: widthContent }}
    >
      <OrganizationForm />
    </Stack>
  );
};

export default CreateOrganizationContainer;
